<template>
    <!--    故事会-->
    <div class="contain_item">
        <router-link class="box_class"
                     :to="{name:'ColumnPaints', params:{code:itemData.code}}"
        >
            <img class="img_class" :src="itemData.cover" alt=""/>
            <div class="title_class">
                {{itemData.title}}
            </div>
            <div class="look_warn_box">
                <div class="look_warn">立即查看</div>
            </div>
        </router-link>
    </div>
</template>

<script>
export default{
    name:'paints',
    props:{
        itemProp:{
            type: Object,
            default(){
                return {}
            },
        }
    },
    data(){
        return {
            itemData:{}
        }
    },
    created(){
        console.log(this.itemData)
        this.initData()
    },
    methods:{
        initData(){
            this.itemData = this.itemProp;
            this.itemData.title = this.itemData.title || '';
            this.itemData.cover = this.itemData.cover || ''
        }
    }

}

</script>

<style scoped>
.contain_item{
    width:36vw;
    height:32vw;
    display:flex;
    justify-content: center;
    align-items:flex-end;
    box-sizing: border-box;
}

.box_class{
    width:90%;
    height:90%;
    box-sizing: border-box;
    position: relative;
}
.img_class{
    width:100%;
    /*height:100%;*/
    object-fit: cover;
    box-sizing: border-box;
    display:inline-block;
    position: absolute;
    z-index: 5;
    border-radius: 5px;
}


.title_class{
    width:100%;
    height:20px;
    line-height:20px;
    text-align: center;
    position: absolute;
    bottom: 20%;
    color:black;
    font-size:16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
    z-index: 10;
    padding:0 5px;
}
.look_warn_box{
    width:100%;
    height:20px;
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    z-index: 10;
    display:flex;
    justify-content: center;
    align-items: center;

}
.look_warn{
    width:75%;
    height:20px;
    line-height: 20px;
    text-align: center;
    border-radius: 10px;
    background-color: RGBA(79, 173, 248, 1);
    font-size: 15px;
    color: white;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding:0 3px;
}


</style>
